;(function () {

"use strict";

var SliderView = require('../views/slider');

var PageView = Backbone.View.extend({
  initialize: function () {
    // console.log('initialized blog view');
    new SliderView({ el: this.$el.find('.featured-articles .slider') });
  }
});

module.exports = PageView;

}());